const Caption = ({children}) => <caption>{children}</caption>;
export { Caption }